import React, { useMemo } from "react";
import { ChatScopeContext, StreamingChat, type ChatScope } from "@/features/chat";
import { DOCK_COMPACT_BUBBLE_WIDTH } from "../constants";
import { useChatDock } from "../hooks/use-chat-dock";
import { useChatDockStore } from "../store/chat-dock-store";

/**
 * Dock içinde çalışan gerçek konuşma. StreamingChat'e route yerine
 * ChatScope üzerinden kimlik ve ilk mesajı verir; motorun geri kalanı
 * (stream, kuyruk, ekler, mesaj aksiyonları) tam sayfayla aynıdır.
 */
export const ChatDockConversation: React.FC = () => {
  const { module, chatId, pending, consumePending } = useChatDock();
  const dockWidth = useChatDockStore((s) => s.width);

  const scope = useMemo<ChatScope>(
    () => ({
      surface: "dock",
      compactBubbles: dockWidth < DOCK_COMPACT_BUBBLE_WIDTH,
      chatId,
      module: module?.id,
      pending: pending && pending.chatId === chatId ? pending : null,
      consumePending,
    }),
    [module?.id, chatId, pending, consumePending, dockWidth],
  );

  if (!chatId) return null;

  return (
    <ChatScopeContext.Provider value={scope}>
      {/* key: konuşma değişince motor sıfırdan kurulsun (pending guard, scroll) */}
      <div
        key={chatId}
        className="relative flex min-h-0 flex-1 flex-col [&>div]:min-h-0 [&>div]:flex-1"
      >
        <StreamingChat />
      </div>
    </ChatScopeContext.Provider>
  );
};
